import React from 'react';
import Element from '../../../components/element';
import Text from '../../../components/text';
import IconNoData from '../../../assets/icons/IconNoData.png';

const NoData = () => {
  return (
    <Element textAlign="center" marginTop="100px">
      <img src={IconNoData} />
      <Element>
        <Text family="GTAM" size="21px" color="#959595">
          No Data To Display
        </Text>
      </Element>
      <Element>
        <Text family="GTAR" size="14px" color="#959595">
          This station was voluntarily skipped, or was offline during your
          visit.
        </Text>
      </Element>
    </Element>
  );
};

export default NoData;
